import { gql } from '@apollo/client';

export const GET_FACEBOOK_PAGES = gql`
  query GetFacebookPages($input: GetFacebookPagesInput!) {
    getFacebookPages(input: $input) {
      sessionId
      pages {
        id
        name
        username
        link
        followersCount
        picture
      }
    }
  }
`;
